import React from "react"
import withApolloClient from "../withApolloClient"
import styled from "styled-components"
import { useQuery } from "@apollo/react-hooks"
import gql from "graphql-tag"
import { Spacer, WebView, MobileView } from "../../styles/common"
import { navigate } from "gatsby"
import { trimText } from "../../utils/utils"
import { FullSlider, getFormattedCurrency } from "@omnichannel/ace-b2b-elements"
import { APP_ID } from "../../helpers/constants"

const MainContainer = styled.div`
  width: 100%;
  /* background-color: #e8171e; //#E61838; // #DF0404; //#c2171d; */
  background-image: radial-gradient(circle, #fa0404, #e8171e 60%, #DF0404 90%, #c2171d);
`

const Content = styled.div`
  max-width: 140rem;
  margin: auto;
  margin-top: 2rem;
  padding: 3rem 4rem 8rem;
  width: 100%;
  height: auto;
  display: block;
  @media (max-width: 767px) {
    padding: 1rem 1.4rem 1rem;
  }
`

const MainLabel = styled.div`
  font-size: 2.4rem;
  font-weight: 600;
  color: #fff;
  width: 100%;
  text-align: left;
  /* @media (min-width: 768px) {
    text-align: left;
  } */
`

const SubLabel = styled.div`
  font-size: 1.6rem;
  font-weight: 300;
  color: #fff;
  width: 100%;
  text-align: left;
  /* @media (min-width: 768px) {
    text-align: left;
  } */
`

const ProductRow = styled.div`
  display: grid;
  max-height: 46.4rem;
  width: 100%;
  height: 100%;
  background-color: #F8F8F8;
  grid-template-columns: 35% 65%;
`

const LargeCardContainer = styled.div`
  position: relative;
  width: 100%;
  /* padding: 1rem; */
  background-color: #fff;
  cursor: pointer;
  min-width: 27rem;
  margin: 0rem .4rem 2rem;
  padding: 1rem;
  @media (min-width: 411px) {
    min-width: 29rem;
  }
  @media (min-width: 500px) {
    min-width: 22rem;
  }
  @media (min-width: 600px) {
    min-width: 26rem;
  }
  @media (min-width: 700px) {
    min-width: 29rem;
  }
  @media (min-width: 768px) {
    min-width: 24rem;
    width: 99.5%;
    margin: 0;
  }
  @media (min-width: 960px) {
    padding: 3rem;
    margin: 0%;
  }
`

const LargeCardSeeAllBox = styled(LargeCardContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
`

const LargeCardSeeAllLabel = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  color:  ${props => props.theme[APP_ID].tertiary};
  cursor: pointer;
`

const SmallCardGrid = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50% 50%;
  background-color: #F8F8F8;
`

const ProductImage = styled.img`
  width: 100%;
`

const LargeCardDetails = styled.div`
  position: absolute;
  bottom: 0rem;
  left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 2rem 0;
`

const LargeCardDetailsMobile = styled(LargeCardDetails)`
  position: static;
  padding: 1rem 0 .6rem 0;
`

const ItemName = styled.div`
  font-size: 1.4rem;
  -webkit-line-clamp: 3;
  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
  @media (min-width: 1024px) {
    font-size: 1.4rem;
  }
`

const DiscountTag = styled.div`
  font-size: 1.2rem;
  color: #fff;
  font-weight: 400;
  padding: 0.4rem 1rem;
  /* background-color: #c2171d; */
  background-color: ${props => props.theme[APP_ID].tertiary};
  width: fit-content;
  opacity: .9;
`

const DiscountTagLargeCardDetailsMobile = styled(DiscountTag)`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  white-space: nowrap;
  justify-content: center;
  padding: .6rem 1rem;
  font-size: 1.4rem;
  width: 8rem;
`

const CurrentPrice = styled.div`
  font-size: 2.2rem;
  font-weight: 600;
`

const ReferencePrice = styled.div`
  font-size: 1.5rem;
  color: ${props => props.theme.default.primary};
  text-decoration: line-through;
`

const SmallCardContainer = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  justify-content: space-between;
  padding: 1rem;
  height: 100%;
  cursor: pointer;
  /* margin: 0 .2rem; */
  width: 99.5%;
  height: 99%;
`

const SmallCardDetails = styled.div`
  width: 50%;
  flex: 1;
`

const SmallProductImage = styled.img`
  width: 100%;
`

const ImageContainer = styled.div`
  width: 50%;
  flex: 1;
`

const SmallDiscountTag = styled.div`
  font-size: 1.2rem;
  color: #fff;
  font-weight: 400;
  padding: 0.4rem 1rem;
  background-color: ${props => props.theme[APP_ID].tertiary};
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  opacity: .9;
`

const MobileScroll = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  flex-direction: row;
  padding: 0 0 0 .8rem;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

// const ShowButtonContainer = styled.div`
//   width: 100%;
// `

// const ShowButton = styled.div`
//   color: #fff;
//   cursor: pointer;
//   margin: auto;
//   padding: 1rem 4rem;
//   font-size: 1.5rem;
//   font-weight: 600;
//   border: 1px solid #fff;
//   border-radius: 1rem;
//   margin-bottom: 2rem;
//   width: fit-content;
// `

const LargeItemCard = props => {
  const { item } = props
  return (
    <LargeCardContainer onClick={() => navigate("/product/" + item._id)}>
      <ProductImage src={item.image.base64_500} />
      <LargeCardDetails>
        <DiscountTag>{item.discount}% OFF</DiscountTag>
        <div>
          <ReferencePrice>P{getFormattedCurrency(item.referencePrice)}</ReferencePrice>
          <CurrentPrice>P{getFormattedCurrency(item.currentPrice)}</CurrentPrice>
          <ItemName>{item.commercialName}</ItemName>
        </div>
      </LargeCardDetails>
    </LargeCardContainer>
  )
}

const LargeItemCardMobile = props => {
  const { item } = props
  return (
    <LargeCardContainer onClick={() => navigate("/product/" + item._id)}>
      <div style={{ position: 'relative' }}>
        <ProductImage src={item.image.base64_500} />
        <DiscountTagLargeCardDetailsMobile>{item.discount}% OFF</DiscountTagLargeCardDetailsMobile>
      </div>
      <LargeCardDetailsMobile>
        <div>
          <ReferencePrice>P{getFormattedCurrency(item.referencePrice)}</ReferencePrice>
          <CurrentPrice>P{getFormattedCurrency(item.currentPrice)}</CurrentPrice>
          <ItemName>{item.commercialName}</ItemName>
        </div>
      </LargeCardDetailsMobile>

    </LargeCardContainer>
  )
}

const SmallItemCard = props => {
  const { item } = props
  return (
    <SmallCardContainer onClick={() => navigate("/product/" + item._id)}>
      <SmallCardDetails>
        <ReferencePrice>P{getFormattedCurrency(item.referencePrice)}</ReferencePrice>
        <CurrentPrice>P{getFormattedCurrency(item.currentPrice)}</CurrentPrice>
        <ItemName>{trimText(item.commercialName, null, 40)}</ItemName>
      </SmallCardDetails>
      <ImageContainer>
        <SmallProductImage src={item.image.base64_500} />
      </ImageContainer>
      <SmallDiscountTag>{item.discount}% OFF</SmallDiscountTag>
    </SmallCardContainer>
  )
}

const RedHotSale = props => {
  const { data, loading } = useQuery(ProductsQuery, {
    variables: {
      offset: 0,
      limit: 10,
      sortBy: "discount",
      sortOrder: -1,
      brands: [],
      subCategoryFilter: null,
      discount: 20,
    },
  })

  if (
    loading ||
    data === null ||
    data === undefined ||
    data.productsWithDiscountPlain === null ||
    data.productsWithDiscountPlain.skus.length === 0
  )
    return null
  const page1 = data.productsWithDiscountPlain.skus.slice(0, 5)
  const page2 = data.productsWithDiscountPlain.skus.slice(5, 10)

  const mobileItems = data.productsWithDiscountPlain.skus

  return (
    <MainContainer>
      <Content>
        <MainLabel>Red Hot Deals</MainLabel>
        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "baseline" }}>
          <SubLabel>Up to {page1[0].discount}% off on selected items</SubLabel>
          <WebView>
            <div style={{
              whiteSpace: "nowrap",
              fontSize: "1.4rem",
              color: "#FFF",
              fontWeight: "500",
              cursor: "pointer"
            }}
              onClick={() => navigate("/sale")}
            >{"SHOW ALL >"}</div>
          </WebView>
        </div>
        <Spacer height={"1rem"} />
        <WebView style={{ marginTop: "1.2rem" }}>
          <FullSlider
            slides={1}
            dots
            autoplay
            infinite
            dotsActiveColor="#FFF"
            // dotsActiveColor="#FFF"
            dotsPassiveColor="#FFF"
            dotsFontSize="1rem"
            dotsBottomOffset="-3rem"

          >
            <ProductRow>
              <LargeItemCard item={page1[0]} key="1000" />
              <SmallCardGrid>
                {page1.map((item, index) => {
                  if (index === 0) {
                    return
                  } else {
                    return <SmallItemCard item={item} key={index} />
                  }
                })}
              </SmallCardGrid>
            </ProductRow>
            <ProductRow>
              <LargeItemCard item={page2[0]} key="1002" />
              <SmallCardGrid>
                {page2.map((item, index) => {
                  if (index === 0) {
                    return
                  } else {
                    return <SmallItemCard item={item} key={index} />
                  }
                })}
              </SmallCardGrid>
            </ProductRow>
          </FullSlider>
        </WebView>
      </Content>
      <MobileView>
        <MobileScroll>
          {mobileItems.map((item, index) => {
            return <LargeItemCardMobile key={index} item={item} />
          })}
          <LargeCardSeeAllBox key="1003" onClick={() => navigate("/sale")}>
            <LargeCardSeeAllLabel>{"SHOW ALL >"}</LargeCardSeeAllLabel>
          </LargeCardSeeAllBox>
        </MobileScroll>
        <Spacer height={"3rem"} />
      </MobileView>
    </MainContainer>
  )
}

const ProductsQuery = gql`
  query seeAllProductsQuery(
    $offset: Int
    $limit: Int
    $sortBy: String
    $sortOrder: Int
    $brands: [String]
    $minPrice: Float
    $maxPrice: Float
    $subCategoryFilter: [String]
    $discount: Int
  ) {
    productsWithDiscountPlain(
      offset: $offset
      limit: $limit
      sortBy: $sortBy
      sortOrder: $sortOrder
      brands: $brands
      minPrice: $minPrice
      maxPrice: $maxPrice
      subCategoryFilter: $subCategoryFilter
      discount: $discount
    ) {
      totalCount
      skus {
        _id
        commercialName
        productName
        currentPrice
        referencePrice
        salePrice
        discount
        primaryImageId
        image {
          _id
          base64_500
        }
      }
    }
  }
`

export default withApolloClient(RedHotSale, {
  client: "seeAllClient",
})
